var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('day-wrapper',{attrs:{"seed":_vm.seed,"reload":_vm.loadData}},[_c('div',_vm._l((_vm.result),function(text,idx){return _c('div',{key:idx},[_vm._v("\n        "+_vm._s(text)+"\n      ")])}))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }